export const counties = [
    { option: "Carlow", label: "Carlow" },
    { option: "Cavan", label: "Cavan" },
    { option: "Clare", label: "Clare" },
    { option: "Cork", label: "Cork" },
    { option: "Donegal", label: "Donegal" },
    { option: "Dublin", label: "Dublin" },
    { option: "Galway", label: "Galway" },
    { option: "Kerry", label: "Kerry" },
    { option: "Kildare", label: "Kildare" },
    { option: "Kilkenny", label: "Kilkenny" },
    { option: "Laois", label: "Laois" },
    { option: "Leitrim", label: "Leitrim" },
    { option: "Limerick", label: "Limerick" },
    { option: "Longford", label: "Longford" },
    { option: "Louth", label: "Louth" },
    { option: "Mayo", label: "Mayo" },
    { option: "Meath", label: "Meath" },
    { option: "Monaghan", label: "Monaghan" },
    { option: "Offaly", label: "Offaly" },
    { option: "Roscommon", label: "Roscommon" },
    { option: "Sligo", label: "Sligo" },
    { option: "Tipperary", label: "Tipperary" },
    { option: "Waterford", label: "Waterford" },
    { option: "Westmeath", label: "Westmeath" },
    { option: "Wexford", label: "Wexford" },
    { option: "Wicklow", label: "Wicklow" }
]